export enum ASSET_CATEGORY_TYPES {
  ALL = 'ALL',
  IMAGE_PLANE = 'IMAGE_PLANE',
  MODELS = 'OTHER',
  VIDEO_PLANE = 'VIDEO_PLANE',
  POSITIONAL_AUDIO = 'POSITIONAL_AUDIO',
  SCREEN_SHARE = 'SCREEN_SHARE',
  AI_AVATARS = 'AI_AVATARS',
  INITIAL_POINT = 'INITIAL_POINT',
  PORTAL = 'PORTAL',
  LIGHT = 'LIGHT',
  WATER_SHADER = 'WATER_SHADER',
  UNKNOWN = 'UNKNOWN',
  NPC_AVATARS = 'NPC_AVATARS',
}

export enum ASSET_PREVIEW_TYPES {
  AUDIO_PREVIEW = 'audio-preview',
  INITIAL_POINT_PREVIEW = 'initial-point-preview',
  PORTAL_PREVIEW = 'portal-preview',
  IMAGE_PREVIEW = 'image-preview',
  VIDEO_PREVIEW = 'video-preview',
  DEFAULT_PREVIEW = 'default-preview',
  WATER_SHADER_PREVIEW = 'water-shader-preview',
  MODEL_PREVIEW = 'model-preview',
}

export enum OBJECT_TYPE_NAMES {
  PORTAL = 'Portal',
  LIGHT = 'Light',
  POSITIONAL_AUDIO = 'Positional audio',
  IMAGE_PLANE = 'Image plane',
  VIDEO_PLANE = 'Video plane',
  SCREEN_SHARE = 'Screen share',
  AI_AVATAR = 'AI Avatar',
  NPC_AVATAR = 'NPC Avatar',
  INITIAL_POINT = 'Initial Point',
  ASSET = 'Asset',
  UNKNOWN = 'Unknown',
}
